import CachedIcon from '@mui/icons-material/Cached';
import { Card, CardContent, CardHeader, CircularProgress, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { connect } from "react-redux";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { LoRaConnectionStatusModel } from '../../../models';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';
import FetchHelper from '../../FetchHelper';
import { actionCreators, ApplicationState, FetchState, selectors } from '../../../store';

const NO_OF_POLLING_TOPIC = 3;
const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    isRefreshAllCompleted: (status: number) => { },
    loadingRefreshAll: [false],
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
    isRefreshGroup: false,
    setRefreshGroup: (refreshGroup: boolean, name: string) => { },
    isDisbleRefeshBtn: true,
}

type LoRaConnectionStatusProps = {
    defaultData: LoRaConnectionStatusModel | undefined;
};

export type PureLoRaConnectionStatusProps = LoRaConnectionStatusProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

const fetchId = "LORA_CONNECTION_STATUS_FETCH";
export const LoRaConnectionStatus_JSPDevice = (props: PureLoRaConnectionStatusProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isRefreshGroup, isDisbleRefeshBtn } = props;
    const { onError, onRefresh, isRefreshAllCompleted, setDisabledRefreshGroupBtn, setRefreshGroup } = props;
    const [loRaConnectionStatus, setLoRaConnectionStatus] = React.useState<LoRaConnectionStatusModel>(props.fetchState.data);
    const [refreshFlg, setRefreshFlg] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "PG";
        params.set("code", code);
        params.set("mainid", mainid);
        return params;
    }

    // デマンド現在値取得成功時
    const handleFetchSuccess = (data: any, isClickedRefreshBtn: boolean) => {
        setRefreshFlg(false);
        const resData = {
            mainid: data.mainid,
            t3al: data.t3al,
            ai1: data.ai1,
            ai2: data.ai2,
            ai3: data.ai3,
            ai4: data.ai4,
            kwhPulse: data.kwh_pulse,
            lastGetDatetime: data.last_get_datetime,
        } as LoRaConnectionStatusModel;
        setLoRaConnectionStatus(resData);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
    };

    const handleError = (success: boolean, data: any, error: any) => {
        setRefreshFlg(false);
        onError(success, data, error);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        setIsRefreshSuccess(false);
    }

    const handleRefresh = () => {
        setRefreshFlg(true);
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params);
    };

    const handleRefreshSuccess = (data: any, fetchId: string) => {
        handleFetchSuccess(data, true);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh();
        }
        isRefreshGroup && handleRefresh();
        isRefreshAllBegin > 0 || isRefreshGroup ? setRefreshFlg(true) : setRefreshFlg(false);
    }
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, isRefreshGroup]);

    React.useEffect(() => {
        setDisabledRefreshGroupBtn(refreshFlg, fetchId);
        // eslint-disable-next-line
    }, [refreshFlg]);

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, false);
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={isDisbleRefeshBtn || refreshFlg}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || refreshFlg ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='LoRa接続状態'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {(fetchState.loading || loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className={'polling'} style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>T3AL</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>T3AI1</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>T3AI2</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>T3AI3</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>T3AI4</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>TJ3 Pulse</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className={'polling'} style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>T3AL</td>
                                    <td style={pollingColStyle}>{loRaConnectionStatus?.t3al}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>T3AI1</td>
                                    <td style={pollingColStyle}>{loRaConnectionStatus?.ai1}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>T3AI2</td>
                                    <td style={pollingColStyle}>{loRaConnectionStatus?.ai2}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>T3AI3</td>
                                    <td style={pollingColStyle}>{loRaConnectionStatus?.ai3}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>T3AI4</td>
                                    <td style={pollingColStyle}>{loRaConnectionStatus?.ai4}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>TJ3 Pulse</td>
                                    <td style={pollingColStyle}>{loRaConnectionStatus?.kwhPulse}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{loRaConnectionStatus?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >
            <FetchHelper fetchId={fetchId} onComplete={(success, data, error) => success ? handleRefreshSuccess(data, fetchId) : handleError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onRefresh: (params: any) => actionCreators.fetch(fetchId, `/polling-udp/get`, "GET", params),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "LoRa接続状態取得",
            body: "LoRa接続状態取得できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoRaConnectionStatus_JSPDevice);


